// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerNav {
  top: 0;
  width: 100vw;
  height: 80px;
  background: #4a88b1;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  z-index: 1000;
  padding: 0 20px;
  box-sizing: border-box;
}

.containerNav h1 {
  font-size: 18px;
  color: white;
  position: absolute;
  left: 275px;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
}

.divOptionsInput {
  margin-left: 70%;
}

.inputContainer {
  position: relative;
}

.inputDiv {
  display: flex;
  align-items: center;
  position: relative;
}

.inputSearch {
  border-radius: 24px;
  padding: 10px 24px 10px 44px;
  padding-right: 40px;
  border: none;
  width: 220px;
  height: 20px;
  color: #274a62;
  background-color: rgb(255 254 254);
  font-size: 14px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.disablePointer {
  pointer-events: none;
}

.cite-box {
  background-color: #f4fff1;
  border: 1px solid #ade19f;
}

.clearButton {
  position: absolute;
  right: 10px; /* Adjust the right position to align within the input field */
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  background: none;
  border: none;
  color: grey;
  cursor: pointer;
}

.clearButton:hover {
  color: #000;
}

.searchIcon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  pointer-events: none;
}

.searchResults {
  position: absolute;
  top: calc(97% + 5px);
  width: 301px;
  background-color: white;
  border: none;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 300px;
  z-index: -5;
  overflow-y: auto;
  box-sizing: border-box;
  margin-left: 6px;
  border-radius: 5px;
  font-size: 14px;
}

.searchResultItem {
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.searchResultItem:hover {
  background-color: rgb(224, 224, 224);
}

.titleResult {
  color: #185177;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  margin-bottom: 4px;
}

.previewTextResult {
  display: inline;
  color: #333;
}

.highlight {
  background-color: yellow;
}

@media (max-width: 1223px) {
  .searchResults {
    position: absolute;
    top: calc(100% + 5px);
    width: 75%;
    background-color: white;
    border: none;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1500;
    max-height: 300px;
    overflow-y: auto;
    box-sizing: border-box;
    margin-left: 28px;
    border-radius: 5px;
    font-size: 14px;
    pointer-events: auto; /* Allow interaction with the search results */
  }

  .containerNav h1 {
    padding-left: 0px;
    top: 50%;
    transform: translateY(-50%);
    margin: 0;
  }

  .clearButton {
    position: absolute;
    right: 30px; /* Adjust the right position to align within the input field */
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    background: none;
    border: none;
    color: grey;
    cursor: pointer;
  }

  .inputSearch {
    border-radius: 24px;
    padding: 10px 24px 10px 44px;
    border: none;
    width: 50% !important;
    height: 15px;
    color: #274a62;
    background-color: rgb(255 254 254);
    font-size: 14px;
    font-weight: 400;
  }

  .inputContainer {
    margin-right: 0px;
  }

  .searchIcon {
    position: absolute;
    left: 30px;
    top: 50%;
    transform: translateY(-50%);
    height: 18px;
    pointer-events: none;
  }

  .inputDiv {
    display: flex;
    align-items: center;
    position: relative;
    align-content: center;
    justify-content: center;
  }
}

.no-underline {
  text-decoration: none;
}

/* @media (max-width: 845px) and (min-width: 535px) {
  .inputContainer {
    background-color: coral;
    top: 20px;
    left: -290px;
  }

  .containerNav {
    height: 100px;
  }

  .containerNav h1 {
    position: absolute;
    font-size: 16px;
    margin-top: -20px;
    left: 264px;
  }

  .contentContainer {
    margin-top: 70px;
  }
} */

@media (max-width: 963px) {
  .containerNav {
    flex-direction: column; /* Stack items vertically */
    height: auto; /* Adjust height to fit content */
    justify-content: flex-start; /* Align items to the top */
    padding: 10px 20px; /* Add padding for better spacing */
  }

  .containerNav h1 {
    position: relative; /* Remove absolute positioning */
    left: 0;
    top: 0;
    transform: none; /* Reset vertical alignment */
    font-size: 16px; /* Adjust font size for smaller screens */
    margin-top: 10px; /* Add spacing above the title */
    margin-bottom: 10px; /* Add spacing below the title */
    text-align: center; /* Center the title */
  }

  .divOptionsInput {
    margin-left: 0;
    width: 100%; /* Make the input take full width */
    display: flex;
    justify-content: center; /* Center the search input */
  }

  .inputSearch {
    width: 80%; /* Make the input take up 80% of the screen width */
    height: 14px; /* Increase height for better touch experience */
  }

  .searchResults {
    width: 75%; /* Make search results take up more width */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf;wEACsE;AACxE;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,8DAA8D;EAC3E,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf;wEACsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB,EAAE,8CAA8C;EACtE;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW,EAAE,8DAA8D;IAC3E,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;EACE;IACE,sBAAsB,EAAE,2BAA2B;IACnD,YAAY,EAAE,iCAAiC;IAC/C,2BAA2B,EAAE,2BAA2B;IACxD,kBAAkB,EAAE,mCAAmC;EACzD;;EAEA;IACE,kBAAkB,EAAE,gCAAgC;IACpD,OAAO;IACP,MAAM;IACN,eAAe,EAAE,6BAA6B;IAC9C,eAAe,EAAE,yCAAyC;IAC1D,gBAAgB,EAAE,gCAAgC;IAClD,mBAAmB,EAAE,gCAAgC;IACrD,kBAAkB,EAAE,qBAAqB;EAC3C;;EAEA;IACE,cAAc;IACd,WAAW,EAAE,mCAAmC;IAChD,aAAa;IACb,uBAAuB,EAAE,4BAA4B;EACvD;;EAEA;IACE,UAAU,EAAE,mDAAmD;IAC/D,YAAY,EAAE,gDAAgD;EAChE;;EAEA;IACE,UAAU,EAAE,2CAA2C;EACzD;AACF","sourcesContent":[".containerNav {\n  top: 0;\n  width: 100vw;\n  height: 80px;\n  background: #4a88b1;\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  z-index: 1000;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n.containerNav h1 {\n  font-size: 18px;\n  color: white;\n  position: absolute;\n  left: 275px;\n  top: 50%;\n  transform: translateY(-50%);\n  margin: 0;\n}\n\n.divOptionsInput {\n  margin-left: 70%;\n}\n\n.inputContainer {\n  position: relative;\n}\n\n.inputDiv {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.inputSearch {\n  border-radius: 24px;\n  padding: 10px 24px 10px 44px;\n  padding-right: 40px;\n  border: none;\n  width: 220px;\n  height: 20px;\n  color: #274a62;\n  background-color: rgb(255 254 254);\n  font-size: 14px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n.disablePointer {\n  pointer-events: none;\n}\n\n.cite-box {\n  background-color: #f4fff1;\n  border: 1px solid #ade19f;\n}\n\n.clearButton {\n  position: absolute;\n  right: 10px; /* Adjust the right position to align within the input field */\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 14px;\n  background: none;\n  border: none;\n  color: grey;\n  cursor: pointer;\n}\n\n.clearButton:hover {\n  color: #000;\n}\n\n.searchIcon {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 18px;\n  pointer-events: none;\n}\n\n.searchResults {\n  position: absolute;\n  top: calc(97% + 5px);\n  width: 301px;\n  background-color: white;\n  border: none;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-height: 300px;\n  z-index: -5;\n  overflow-y: auto;\n  box-sizing: border-box;\n  margin-left: 6px;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n.searchResultItem {\n  padding: 8px;\n  cursor: pointer;\n  border-bottom: 1px solid #eee;\n}\n\n.searchResultItem:hover {\n  background-color: rgb(224, 224, 224);\n}\n\n.titleResult {\n  color: #185177;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 14px;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  margin-bottom: 4px;\n}\n\n.previewTextResult {\n  display: inline;\n  color: #333;\n}\n\n.highlight {\n  background-color: yellow;\n}\n\n@media (max-width: 1223px) {\n  .searchResults {\n    position: absolute;\n    top: calc(100% + 5px);\n    width: 75%;\n    background-color: white;\n    border: none;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1500;\n    max-height: 300px;\n    overflow-y: auto;\n    box-sizing: border-box;\n    margin-left: 28px;\n    border-radius: 5px;\n    font-size: 14px;\n    pointer-events: auto; /* Allow interaction with the search results */\n  }\n\n  .containerNav h1 {\n    padding-left: 0px;\n    top: 50%;\n    transform: translateY(-50%);\n    margin: 0;\n  }\n\n  .clearButton {\n    position: absolute;\n    right: 30px; /* Adjust the right position to align within the input field */\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 14px;\n    background: none;\n    border: none;\n    color: grey;\n    cursor: pointer;\n  }\n\n  .inputSearch {\n    border-radius: 24px;\n    padding: 10px 24px 10px 44px;\n    border: none;\n    width: 50% !important;\n    height: 15px;\n    color: #274a62;\n    background-color: rgb(255 254 254);\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .inputContainer {\n    margin-right: 0px;\n  }\n\n  .searchIcon {\n    position: absolute;\n    left: 30px;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 18px;\n    pointer-events: none;\n  }\n\n  .inputDiv {\n    display: flex;\n    align-items: center;\n    position: relative;\n    align-content: center;\n    justify-content: center;\n  }\n}\n\n.no-underline {\n  text-decoration: none;\n}\n\n/* @media (max-width: 845px) and (min-width: 535px) {\n  .inputContainer {\n    background-color: coral;\n    top: 20px;\n    left: -290px;\n  }\n\n  .containerNav {\n    height: 100px;\n  }\n\n  .containerNav h1 {\n    position: absolute;\n    font-size: 16px;\n    margin-top: -20px;\n    left: 264px;\n  }\n\n  .contentContainer {\n    margin-top: 70px;\n  }\n} */\n\n@media (max-width: 963px) {\n  .containerNav {\n    flex-direction: column; /* Stack items vertically */\n    height: auto; /* Adjust height to fit content */\n    justify-content: flex-start; /* Align items to the top */\n    padding: 10px 20px; /* Add padding for better spacing */\n  }\n\n  .containerNav h1 {\n    position: relative; /* Remove absolute positioning */\n    left: 0;\n    top: 0;\n    transform: none; /* Reset vertical alignment */\n    font-size: 16px; /* Adjust font size for smaller screens */\n    margin-top: 10px; /* Add spacing above the title */\n    margin-bottom: 10px; /* Add spacing below the title */\n    text-align: center; /* Center the title */\n  }\n\n  .divOptionsInput {\n    margin-left: 0;\n    width: 100%; /* Make the input take full width */\n    display: flex;\n    justify-content: center; /* Center the search input */\n  }\n\n  .inputSearch {\n    width: 80%; /* Make the input take up 80% of the screen width */\n    height: 14px; /* Increase height for better touch experience */\n  }\n\n  .searchResults {\n    width: 75%; /* Make search results take up more width */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
